import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';

export default function NewSettingTimeSelectBox(props) {
  const { value, setValue, options, disabled, width } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

	const [isClicked, setIsClicked] = useState(false);

	const TopLevelRef = useRef();
	const SelectRef = useRef();


  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
				SelectRef.current.style.border = `1px solid ${theme.line}`;
				SelectRef.current.style.height = `32px`;
				SelectRef.current.style.overflow = 'hidden';

        setTimeout(() => (
          setIsClicked(false)
        ), 150)
    }
  }

  // 선택박스 클릭시 //
	function onClick() {
    if (disabled) return;
		else if (!options[0]) return;

		if (isClicked) {
			SelectRef.current.style.border = `1px solid ${theme.line}`;
			SelectRef.current.style.height = `32px`;
			SelectRef.current.style.overflow = 'hidden';

      setTimeout(() => (
			  setIsClicked(false)
      ), 150)
		}
		else {
			SelectRef.current.style.border = `1px solid ${theme.primary}`;
			const filteredCount = options.filter(opt => opt.name !== value.name).length;
			SelectRef.current.style.height = `${32 * (filteredCount + 1)}px`;
			SelectRef.current.style.maxHeight = '160px';
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

	return (
		<TopLevelWrapper
      ref={TopLevelRef}
      width={width}>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}
        width={width}
        onClick={onClick}>
          <SelectedViewWrapper width={width}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} cursor='pointer'>{value.label}</Text>
            <StyledArrowWrapper>
              <StyledArrow isClicked={isClicked} />
            </StyledArrowWrapper>
          </SelectedViewWrapper>
          {
            isClicked &&
            options.filter(opt => opt.name !== value.name).map((data, index) =>
              <OptionWrapper
                key={'Options-' + index}
                onClick={() => setValue(data)}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} cursor='pointer'>{data.label}</Text>
              </OptionWrapper>
            )
          }
      </SelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;

	width: ${props => props.width}px;
	height: 32px;
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: flex-start;
	align-items: flex-start;

	width: ${props => props.width}px;
	height: 32px;

	border-radius: 8px;
	overflow: hidden;

  border: 1px solid ${props => props.theme.line};
  box-sizing: border-box;
	background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

	&::-webkit-scrollbar {
		// width: 9px;
    width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const SelectedViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

	justify-content: space-between;
	align-items: center;

  padding: 3px 8px;

  width: calc(${props => props.width}px - 17px);

  border-bottom: 1px solid ${props => props.theme.line};
`;

const StyledArrowWrapper = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 15px;
  height: 25px;
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 10px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.theme.subText};
  transform: ${props => props.isClicked ? `rotate(-90deg)` : `rotate(90deg)`};
  transition: transform 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;

	justify-content: flex-start;
	align-items: flex-start;

  padding: 6px 8px;

	width: 100%;

  border-bottom: 1px solid ${props => props.theme.line};

  box-sizing: border-box;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primary};

      & p {
        color: ${props => props.theme.white};
      }
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.theme.text};

  margin: 0px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;